import rlModal from './modal/rlModal';

const overlaysTypes = {
    Modal: rlModal
};

export default overlaysTypes;